module.exports = __webpack_public_path__ + "static/AvenirLTStd-Book-c7084983807c1cef3a30f2d5aa340941.otf";